import React, { useMemo, useState } from 'react';

// Flat rows -> children map. The API returns a flat array so the tree is built here.
export const buildTree = (folders = []) => {
    const byParent = new Map();
    folders.forEach((folder) => {
        const key = folder.PARENT_ID === null || folder.PARENT_ID === undefined ? 'root' : String(folder.PARENT_ID);
        if (!byParent.has(key)) byParent.set(key, []);
        byParent.get(key).push(folder);
    });
    return byParent;
};

export const folderPath = (folders = [], folderId) => {
    const byId = new Map(folders.map((folder) => [String(folder.ID), folder]));
    const chain = [];
    let current = byId.get(String(folderId));
    let guard = 0;
    while (current && guard < 100) {
        chain.unshift(current);
        current = current.PARENT_ID ? byId.get(String(current.PARENT_ID)) : null;
        guard += 1;
    }
    return chain;
};

const Branch = ({ byParent, parentKey, depth, selectedId, onSelect }) => {
    const children = byParent.get(parentKey) || [];
    if (children.length === 0) return null;

    return (
        <ul className="list-unstyled mb-0">
            {children.map((folder) => (
                <Node
                    key={folder.ID}
                    folder={folder}
                    byParent={byParent}
                    depth={depth}
                    selectedId={selectedId}
                    onSelect={onSelect}
                />
            ))}
        </ul>
    );
};

const Node = ({ folder, byParent, depth, selectedId, onSelect }) => {
    const hasChildren = (byParent.get(String(folder.ID)) || []).length > 0;
    const [open, setOpen] = useState(depth === 0);
    const isSelected = String(selectedId) === String(folder.ID);

    return (
        <li>
            <div
                className={`dms-rail-item d-flex align-items-center ${isSelected ? 'selected' : ''}`}
                style={{ paddingLeft: 8 + depth * 14 }}
                onClick={() => onSelect(folder.ID)}
            >
                <i
                    className={`mdi ${hasChildren ? (open ? 'mdi-chevron-down' : 'mdi-chevron-right') : 'mdi-blank'} me-1`}
                    style={{ width: 16 }}
                    onClick={(event) => { event.stopPropagation(); setOpen((prev) => !prev); }}
                />
                <i className="mdi mdi-folder text-warning me-2" />
                <span className="text-truncate" title={folder.FOLDER_NAME}>{folder.FOLDER_NAME}</span>
                {folder.FILE_COUNT > 0 && <span className="ms-auto badge bg-light text-muted">{folder.FILE_COUNT}</span>}
            </div>
            {open && (
                <Branch
                    byParent={byParent}
                    parentKey={String(folder.ID)}
                    depth={depth + 1}
                    selectedId={selectedId}
                    onSelect={onSelect}
                />
            )}
        </li>
    );
};

const FolderTree = ({ folders = [], rootFileCount = 0, selectedId, onSelect }) => {
    const byParent = useMemo(() => buildTree(folders), [folders]);
    const isRoot = selectedId === 'root' || selectedId === null || selectedId === undefined;

    return (
        <div>
            <div
                className={`dms-rail-item d-flex align-items-center ${isRoot ? 'selected' : ''}`}
                onClick={() => onSelect('root')}
            >
                <i className="mdi mdi-home-outline me-2" />
                <span>Home</span>
                {rootFileCount > 0 && <span className="ms-auto badge bg-light text-muted">{rootFileCount}</span>}
            </div>
            <Branch byParent={byParent} parentKey="root" depth={0} selectedId={selectedId} onSelect={onSelect} />
        </div>
    );
};

export default FolderTree;
